<template>
  <div @click="$emit('click')" id="NotificationParent">
    <div v-if="loadingCount">
      <i class="fas fa-sync fa-spin"></i>
    </div>
    <v-popover
      ref="popover"
      v-else
      popoverBaseClass="emptyPopover"
      offset="8"
      :boundariesElement="null"
      @show="onPopoverShow"
    >
      <span id="NotificationBtn">
        <span
          :style="notifyLength ? 'background-color: #e91e63 !important;' : ''"
          >{{ notifyLength > 9 ? "9+" : notifyLength }}</span
        >
        <i class="fas fa-bell"></i>
      </span>

      <div id="NotificationPopup" slot="popover" @scroll="handleScroll">
        <div id="NotificationHeader">
          <div id="NotificationCount">
            {{ notifyLength }} Notificări noi
            <small style="font-size: 1.45rem" @click="closePopover()"
              ><router-link to="/notificari">vezi toate</router-link></small
            >
          </div>
          <div>
            <a
              v-show="notifyLength"
              @click.prevent="readAllNotifications"
              href="#"
              id="NotificationRead"
            >
              Citește tot
              <i class="fas fa-check-double"></i>
            </a>
          </div>
        </div>
        <div v-if="loading" class="NotificationLoading">
          <i class="fas fa-sync fa-spin"></i>
          <span>Se încarcă notificările...</span>
        </div>
        <div v-else-if="!notifyLength" id="NotificationNone">
          <i class="fas fa-bell-slash"></i>
          <h4 class="prettyH4">Nu sunt notificări</h4>
        </div>
        <div v-else id="NotificationBody">
          <div v-for="(notify, i) in notifications" :key="i" class="NotItem">
            <div class="NotItemIcon">
              <div>
                <i class="far fa-bell"></i>
              </div>
            </div>
            <div class="NotItemContent">
              <span class="is-link" @click="openReference(notify)">
                {{ notify.message }} -
                {{
                  new Date(notify.createdAt).toLocaleString("ro-ro", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  })
                }}</span
              >
            </div>
            <div class="NotItemControls">
              <div v-if="notify._loading" data-loadSpin style="width: 3rem">
                <i class="fas fa-sync fa-spin"></i>
              </div>
              <div v-else-if="!notify.isRead" @click="readNotification(notify)">
                Citește <i class="fas fa-check"></i>
              </div>
            </div>
          </div>
          <div v-if="isLoadingMore" class="NotificationLoadMore">
            <i class="fas fa-sync fa-spin"></i>
          </div>
          <div
            v-else-if="!hasMore && notifications.length"
            class="NotificationEnd"
          >
            Nu mai sunt notificări
          </div>
        </div>
      </div>
    </v-popover>
  </div>
</template>

<style src="@/assets/Notification.css"></style>

<script>
import {
  EVENT_NOTIFICATION,
  EVENT_NOTIFICATION_COUNT,
  EVENT_NOTIFICATION_READ,
  EVENT_NOTIFICATION_READ_ALL,
  REFERENCE_ONCE,
  REFERENCE_LAST_VERSION,
  NEEDS_LAST_VERSION,
  ASSIGNMENT_DOCUMENTS,
  VERBAL_PROCESS,
  ANNOUNCEMENT,
} from "@/api.js";
import { mapGetters, mapMutations } from "vuex";

const RELOAD_TIME = 30000;
let HOT_RELOAD_INTERVAL = null;

export default {
  computed: {
    ...mapGetters(["userRole", "notifications"]),
  },
  data() {
    return {
      loadingCount: false,
      loading: false,
      isLoadingMore: false,
      currentPage: 1,
      hasMore: true,
      pageSize: 15,
      notifyLength: 0,
      notificationsLoaded: false,
    };
  },
  watch: {
    userRole() {
      this.starter();
      this.clearNotifycations();
    },
  },
  methods: {
    ...mapMutations({ addWindow: "addWindow", set: "setNotifications" }),

    openReference(notify) {
      if (notify.notifyType == "need-reference") {
        REFERENCE_ONCE(notify.parentId)
          .then((res) => {
            if (
              !this.checkHttpStatusCode(res?.meta?.HttpStatusCode) ||
              (this.isObject(res.data) &&
                (res.data.needReferateStatus == "approved" ||
                  res.data.needReferateStatus == "signature_waiting" ||
                  res.data.needReferateStatus == "signing_failed"))
            ) {
              REFERENCE_LAST_VERSION(notify.parentId).then((res) => {
                if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                  this.readNotification(notify);
                  this.$router.push(
                    `/planificare/referate/${notify.parentId}/${res.data?.result?.versionNumber}`,
                  );
                } else {
                  this.$toastr.w("Referatul nu mai poate fi deschis");
                }
              });
            } else {
              this.readNotification(notify);
              this.$router.push("/planificare/referate/" + notify.parentId);
            }
          })
          .catch(() => {
            this.$toastr.w("Referatul nu mai poate fi deschisă");
          });
      } else if (notify.notifyType == "need") {
        NEEDS_LAST_VERSION(notify.parentId).then((res) => {
          this.openLastVersionNeed(res.data);
          this.readNotification(notify);
          this.$router.push(`/planificare/nevoi`);
        });
      } else if (notify.notifyType == "product") {
        this.$router
          .push({
            path: `/planificare/catalog`,
            query: { product: notify.parentId },
          })
          .catch(() => {});

        this.readNotification(notify);
      } else if (notify.notifyType == "assignmentDocument") {
        this.goToProcedure(ASSIGNMENT_DOCUMENTS.getOne, notify.parentId, "achizitii");
        this.readNotification(notify);
      } else if (notify.notifyType == "announcement") {
        this.goToProcedure(ANNOUNCEMENT.getOne, notify.parentId, "anunt");
        this.readNotification(notify);
      } else if (notify.notifyType == "verbal-process") {
        this.goToProcedure(
          VERBAL_PROCESS.getOne,
          notify.parentId,
          "proces-verbal",
        );
        this.readNotification(notify);
      } else if (notify.notifyType == "paap") {
        this.$router.push(`/planificare/paap`);
        this.readNotification(notify);
      }

      this.closePopover();
    },

    goToProcedure(api, id, type) {
      api(id).then((res) => {
        const data = res?.data?.result;

        const procedura = data.paapCentralization.procedureType.name
          .replace(/ /g, "_")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        const path = `/atribuire/procedura/${procedura}/${data.paapCentralization.id}/${type}`;

        this.$router.push(path);
      });
    },

    async openLastVersionNeed(data) {
      const version = data?.data || null;

      if (typeof version.createdByUser == "string") {
        await USERS_ONCE(version.createdByUser, true)
          .then((res) => {
            res = res?.data?.result || null;
            version.createdBy = {
              last_name: res?.last_name || "-",
              first_name: res?.first_name || "-",
              idConectX: res?.id || "-",
            };
          })
          .catch((err) => {
            this.$toastr.e("Detectarea solicitantului versiunii a eșuat.");
            version.createdBy = {
              last_name: "-",
              first_name: "-",
              idConectX: "-",
            };
          });
      }
      if (typeof data.createdBy == "string") {
        const parseName = data.createdBy.split(" ");
        version.modifiedBy = {
          last_name: parseName[1],
          first_name: parseName[0],
          idConectX: data.createdBy.split("=")[1],
        };
      }
      let approver =
        Array.isArray(version.approvers) && version.approvers[0]
          ? version.approvers[0]
          : false;

      approver = this.JSONvalide(approver)
        ? JSON.parse(approver)[0]?.split("*")
        : this.isString(approver, true)?.split("*") || [];

      this.addWindow({
        title: `Versiunea V${data.versionNumber}`,
        isCurrent: true,
        // subtitle: `Nevoie: ${productName.split(':')[1]}`,
        data: {
          //all: this.Data.VERSIONS,
          needData: {
            ...version,
            showModified: true,
            approver: approver[2] ? approver[2] : false,
          },
          additionalData: data,
          status: version.status,
          canDelete: false,
        },
        modal: 11.1,
      });
    },

    closePopover() {
      const x = this.$refs.popover?.hide;

      if (x) x();
    },
    clearNotifycations() {
      this.set([]);
      this.notificationsLoaded = false;
      this.loading = false;
      this.loadingCount = false;
      this.isLoadingMore = false;
      this.currentPage = 1;
      this.notifyLength = 0;
      this.hasMore = true;
    },

    readAllNotifications() {
      if (!this.notifyLength) return;

      EVENT_NOTIFICATION_READ_ALL().then(() => {
        this.syncData(true);
      });
    },

    fetchCount() {
      EVENT_NOTIFICATION_COUNT().then((res) => {
        if (typeof res?.data?.count === "number") {
          this.notifyLength = res.data.count;
          this.loadingCount = false;
        }
      });
    },

    onPopoverShow() {
      if (!this.notificationsLoaded) {
        this.loading = true;
        this.syncData(true);
      }
    },

    readNotification(data) {
      if (!Number.isInteger(data?.id) || data._loading) {
        return;
      }

      data._loading = true;

      EVENT_NOTIFICATION_READ(data.id).then(() => {
        this.syncData();
      });
    },
    handleScroll(event) {
      const el = event.target;
      const threshold = 50;
      const isNearBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight < threshold;

      if (
        isNearBottom &&
        !this.isLoadingMore &&
        !this.loading &&
        this.hasMore
      ) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.isLoadingMore || !this.hasMore) return;

      this.isLoadingMore = true;
      const nextPage = this.currentPage + 1;

      EVENT_NOTIFICATION(nextPage, this.pageSize).then((e) => {
        this.isLoadingMore = false;
        this.notifyLength = e.data.recordsQuantity;
        if (Array.isArray(e?.data?.result)) {
          const newItems = e.data.result.map((item) => ({
            ...item,
            _loading: false,
          }));
          if (nextPage * this.pageSize > e.data.recordsQuantity) {
            this.hasMore = false;
          }
          if (newItems.length > 0) {
            this.set([...this.notifications, ...newItems]);
            this.currentPage = nextPage;
          } else {
            this.hasMore = false;
          }
        }
      });
    },
    syncData(hiddenSync) {
      if (!hiddenSync) {
        this.clearNotifycations();
        this.hasMore = true;
        this.notificationsLoaded = false;
        this.currentPage = 1;
        this.loading = true;
      }

      this.loading = true;
      EVENT_NOTIFICATION(1, this.pageSize).then((e) => {
        this.loading = false;
        this.notificationsLoaded = true;
        this.notifyLength = e.data.recordsQuantity;
        if (Array.isArray(e?.data?.result)) {
          const items = e.data.result.map((e) => ({ ...e, _loading: false }));
          if (hiddenSync) {
            this.set(items);
            this.currentPage = 1;
            this.hasMore = items.length >= this.pageSize;
          } else {
            this.set(items);
            this.hasMore = items.length >= this.pageSize;
          }
        }
      });
    },
    starter() {
      clearInterval(HOT_RELOAD_INTERVAL);

      this.loadingCount = true;
      this.fetchCount();

      HOT_RELOAD_INTERVAL = setInterval(this.fetchCount, RELOAD_TIME);
    },
  },
  beforeDestroy() {
    clearInterval(HOT_RELOAD_INTERVAL);
  },
  created() {
    this.starter();
  },
};
</script>

<style>
.is-link {
  cursor: pointer;
}
.is-link:hover {
  color: #337ab7;
}

.NotificationLoading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #888;
  gap: 0.5rem;
}
.NotificationLoading i {
  font-size: 2.2rem;
}
.NotificationLoading span {
  font-size: 1.5rem;
}

.NotificationLoadMore,
.NotificationEnd {
  text-align: center;
  padding: 1rem;
  color: #888;
  font-size: 0.9rem;
}
.NotificationLoadMore i {
  font-size: 1.2rem;
}
</style>
